<template>
  <div class="text-input clearfix">
    <div class="form-group" v-bind:class="{ 'has-feedback' : field.dirty }">
      <label v-bind:for="field.name" class="col-sm-4 control-label">{{ field.label }} <span v-if="field.required" class="required">*</span></label>
      <div class="col-sm-8">
        <input v-bind:id="field.name" class="form-control" type="text" v-model="field.value" v-bind:name="field.name"/>
        <span class="form-validation-error" v-show="!field.valid && field.dirty">{{ field.label }} is not valid.</span>
        <span class="fa fa-check form-control-feedback form-control-feedback-success" v-show="field.valid && field.dirty"></span>
        <span class="fa fa-remove form-control-feedback form-control-feedback-error" v-show="!field.valid && field.dirty"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TextInput',
  props: {
    field: {
      type: Object,
      default () {
        return {
          value: '',
          valid: false,
          dirty: false
        }
      }
    }
  },
  data () {
    return {
      isLength: true,
      isRegex: true,
      minLength: 1
    }
  },
  ready () {
    this.validateField(this.field.value)
  },
  watch: {
    'field.value': function (newVal, oldVal) {
      this.validateField(newVal)
    }
  },
  methods: {
    validateField (val) {
      if (val) {
        this.field.dirty = true
        if (this.field.required) {
          this.isLength = this.field.valid = val.length >= this.minLength
        } else {
          this.field.valid = true
        }
      } else if (this.field.required) {
        this.field.valid = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// TextInput.vue?0171996a